import { Fragment } from "react"

interface CompactStepIndicatorProps {
    activeStep: number
    steps: {
        label: string
        key: number
    }[]
    orientation?: "horizontal" | "vertical"
}

const CompactStepIndicator = ({ activeStep, steps, orientation = "horizontal" }: CompactStepIndicatorProps) => {
    if (orientation === "vertical") {
        return (
            <div className="sticky top-20 rounded-lg border bg-card text-card-foreground shadow-sm p-4">
                <div className="flex flex-col gap-3">
                    {steps.map((step, index) => (
                        <Fragment key={step.key}>
                            <div className="flex items-start gap-2">
                                {/* Step indicator circle with connector line */}
                                <div className="flex flex-col items-center">
                                    <div
                                        className={`w-3 h-3 rounded-full flex-shrink-0 transition-all duration-300 ${step.key <= activeStep
                                                ? "bg-primary"
                                                : "bg-gray-200 border border-gray-300"
                                            }`}
                                    />

                                    {/* Connector line */}
                                    {index < steps.length - 1 && (
                                        <div
                                            className={`w-0.5 h-6 mt-1 transition-all duration-300 ${step.key < activeStep
                                                    ? "bg-primary"
                                                    : "bg-gray-200"
                                                }`}
                                        />
                                    )}
                                </div>

                                {/* Step label */}
                                <div className="flex flex-col -mt-0.5">
                                    <span
                                        className={`text-xs font-medium transition-colors duration-300 ${step.key <= activeStep
                                                ? "text-gray-700"
                                                : "text-gray-400"
                                            }`}
                                    >
                                        {step.label}
                                    </span>
                                </div>
                            </div>
                        </Fragment>
                    ))}
                </div>
            </div>
        )
    }

    // Horizontal orientation (default)
    return (
        <div className="w-fit flex flex-wrap items-center py-1 gap-4">
            {steps.map((step, index) => (
                <Fragment key={step.key}>
                    <div className="flex items-center">
                        <div className="flex flex-col items-start">
                            <div className="flex items-center">
                                <div
                                    className={`w-3 h-3 rounded-full mr-2 ${step.key <= activeStep ? "bg-primary" : "bg-gray-200 border border-gray-300"
                                        }`}
                                ></div>
                                <span className={`text-xs font-medium ${step.key <= activeStep ? "text-gray-700" : "text-gray-400"}`}>
                                    {step.label}
                                </span>
                            </div>
                        </div>
                    </div>
                </Fragment>
            ))}
        </div>
    )
}

export default CompactStepIndicator


